export const emptySettings = {
	color: '',
	backgroundColor: '',
	rounded: '',
	buttonColor: '',
	buttonBackground: '',
	buttonBackground2: '',
	headingColor: '',
	headingColor2: '',
	fontSize: '',
	headingFontSize: '',
	fontFamily: '',
	buttonRounded: '',
	buttonBorderWidth: '',
	buttonBorderColor: '',
	cardColor: '',
	cardBackground: '',
	cardBackground2: '',
	cardRounded: '',
	cardBorderWidth: '',
	cardBorderColor: '',
	gtmId: '',
	headingFontFamily: '',
	parse: 'true',
	salutation: 'true',
	icon: '',
	customerName: '',
};

export const resolveSetting = (value, settings) => {
	if (!settings) {
		return value;
	}
	return settings[value] ?? emptySettings[value] ?? value;
};

export const isEmpty = (value) => value === undefined || value === '' || value === null;

export const getBackgroundProp = (props, settings) => {
	const { background, background2, bgGradientDirection } = props;
	return isEmpty(resolveSetting(background2, settings)) ? resolveSetting(background, settings)
		: `linear-gradient(${bgGradientDirection || 'to right'}, ${resolveSetting(background, settings)}, ${resolveSetting(background2, settings)})`;
};
